/**
 * Created By: Tyrus Malmstrom
 * Creation Date: 10/14/2022
 * Description:
 *   - Global vue component that handles rendering our custom Chick-fil-a tag button.
*/

import component from './ChickFilATagButton.vue';

const install = (Vue) => {
  if (install.installed) return;
  install.installed = true;
  Vue.component('ChickFilATagButton', component);
};

const plugin = {
  install,
};

let GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

component.install = install;

// export ChickFilATags component by default
export default component;